import { render, staticRenderFns } from "./CityOfficialsTable.vue?vue&type=template&id=bdc899f6&"
import script from "./CityOfficialsTable.vue?vue&type=script&lang=js&"
export * from "./CityOfficialsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports